<template>
  <div class="wrap">
    <div class="top-avatar">
      <el-image
        style="width: 60px"
        :src="require('@/assets/dash_common/sidebar.png')"
      ></el-image>
    </div>
    <!-- <div class="flex-center active">
      <div>首页</div>
    </div> -->
    <div
      v-for="(item, index) in navList1"
      :key="index"
      @click="handleClick(`${item.val}`)"
      :class="{ active: tabType == item.val }"
      class="nav-wrap"
      style="border-radius: 10px 10px 0 0"
    >
      <div class="border-top flex-center">{{ item.navName }}</div>
    </div>
    <!-- <div
			@click="handleClick('shouye')"
			:class="{active: tabType == 'shouye'}"
			class="nav-wrap"
			style="border-radius: 10px 10px 0 0"
		>
			<div class="border-top flex-center">首页</div>
		</div> 
		 <div
			@click="handleClick('activity')"
			:class="{active: tabType == 'activity'}"
			class="nav-wrap"
			v-if="isshowActivity"
		>
			<div class="border-top flex-center">活动专区</div>
		</div>
		<div
			@click="handleClick('shop')"
			:class="{active: tabType == 'shop'}"
			class="nav-wrap"
		>
			<div class="border-top flex-center">配件商城</div>
		</div>
		<div
			@click="handleClick('source')"
			:class="{active: tabType == 'source'}"
			class="nav-wrap"
		>
			<div class="border-top flex-center">精品车源</div>
		</div>
		<div
			@click="handleClick('auction')"
			:class="{active: tabType == 'auction'}"
			class="nav-wrap"
		>
			<div class="border-top flex-center">竞价中心</div>
		</div> -->
    <div :class="{ active: tabType == 'service' }" class="nav-wrap">
      <div class="border-top flex-center">
        <div class="icon-text-wrap">
          <a
            target="_blank"
            href="http://wpa.qq.com/msgrd?v=3&uin=2086681945&site=qq&menu=yes"
          >
            <div style="width: 16px; height: 12px; margin: auto">
              <el-image
                style="width: 100%; height: 100%; margin: 0 auto"
                fit="contain"
                :src="require('@/assets/dash_common/service.png')"
              />
            </div>
            <div>客服</div>
          </a>
        </div>

        <!-- <div class="icon-text-wrap">
          <div style="width: 16px; height: 12px">
            <el-image
              style="width: 100%; height: 100%; margin: 0 auto"
              fit="contain"
              :src="require('@/assets/dash_common/service.png')"
            />
          </div>
          <div>客服</div>
        </div> -->
      </div>
    </div>
    <div @click="handleToTop" class="nav-wrap">
      <div class="border-top flex-center">
        <div class="icon-text-wrap">
          <div
            class="el-icon-arrow-up"
            style="font-size: 13px; font-weight: 600"
          ></div>
          <div>顶部</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    listActivity: Array,
    tabType: String,
    backPosition: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isshowActivity: true,
      navList: [
        { navName: "首页", val: "shouye", navIcon: "icon" },
        { navName: "活动专区", val: "activity", navIcon: "icon" },
        { navName: "配件商城", val: "shop", navIcon: "icon" },
        { navName: "精品车源", val: "source", navIcon: "icon" },
        { navName: "竞价中心", val: "auction", navIcon: "icon" },
      ],
      navList1: [],
    };
  },
  computed: {
    ...mapGetters(["token"]),
  },
  watch: {
    listActivity: {
      handler(e) {
        console.log(e);
        // console.log(e[1], 89)
        if (e[1].Name == "") {
          this.navList.splice(
            this.navList.findIndex((item) => item.navName == "活动专区"),
            1
          );
          this.navList1 = this.navList;
        } else {
          console.log(this.navList);
          this.navList1 = this.navList;
        }
      },
      deep: true,
    },
  },
  methods: {
    handleLogin() {
      this.$emit("login", true);
    },
    handleClick(val) {
      console.log(val);
      if (!this.token) {
        if (this.tabType == val) return;
        this.$emit("scroll", val);
        this.handleLogin();
        // return true;
      } else {
        // this.handleToList(item);
        if (this.tabType == val) return;
        this.$emit("scroll", val);
        // this.$emit("update:tab-type", val);
      }
    },
    handleToTop() {
      if (this.isMoving) return;
      const start = window.pageYOffset;
      let i = 0;
      this.isMoving = true;
      this.interval = setInterval(() => {
        const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
        if (next <= this.backPosition) {
          window.scrollTo(0, this.backPosition);
          clearInterval(this.interval);
          this.isMoving = false;
        } else {
          window.scrollTo(0, next);
        }
        i++;
      }, 16.7);
    },
    easeInOutQuad(t, b, c, d) {
      if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
      return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-wrap {
  cursor: pointer;
  padding: 0 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(29, 32, 137, 1);
  display: flex;
  justify-content: center;
  .border-top {
    border-top: 1px solid rgba(29, 32, 137, 1);
  }

  &.active {
    .border-top {
      border-top: none;
    }
  }
}

// div:nth-of-type(2).nav-wrap{
//    background-color: red!important;
// }
// .nav-wrap:nth-of-type(2){
//     background-color: red;
// }
.nav-wrap.active + .nav-wrap {
  .border-top {
    border-top: none;
  }
}

.icon-text-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.top-avatar {
  position: absolute;
  top: -47px;
  right: 50%;
  transform: translateX(50%);
}
.wrap {
  position: relative;
  width: 50px;
  height: 350px;
  display: grid;
  grid-template-rows: repeat(7, 1fr);
  border-radius: 10px;
  justify-content: center;
  background: rgba(255, 255, 255, 1);
  .active {
    background: rgba(255, 141, 26, 1);
    font-size: 15px;
    font-weight: 700;
    line-height: 20px;
    color: rgba(255, 255, 255, 1);
  }
  //   .shouye-wrap {
  //     background: rgba(255, 141, 26, 1);
  //     font-size: 15px;
  //     font-weight: 700;
  //     line-height: 20px;
  //     color: rgba(255, 255, 255, 1);
  //     border-radius: 10px 10px 0 0;
  //   }
}
</style>
